@if(photographer){
  <ng-container>
    <div class="flex-1 overflow margin-bottom margin-top">
      <bt-loader [loaderId]="loaderId">
        <div class="margin-bottom-small">Status</div>
        <div class="margin-bottom">
          @if(status.data){
            <bt-autocomplete [datasource]="status.data"
                             [currentSelected]="status.selected"
                             [settings]="status.autocompleteSettings"
                             [loaderId]="loaderId"
                             (selected)="onSelectStatus($event)"></bt-autocomplete>
          }
        </div>
        <div class="margin-bottom-small margin-top">Cost per shot</div>
        <div class="flex center margin-bottom-small">
          <div class="flex-1 margin-right">
            <input type="number"
                   min="1"
                   step="any"
                   class="full-width"
                   [(ngModel)]="photographer.shotCost">
          </div>
          <div class="flex-0">
            <select>
              <option value="€">€</option>
            </select>
          </div>
        </div>
        <div class="margin-bottom-small margin-top">Max Items</div>
        <input type="number"
               [(ngModel)]="photographer.maxItems">
        <div class="margin-bottom-small margin-top">Discount</div>
        <input type="number"
               class="margin-right-small"
               [(ngModel)]="photographer.discountThreshold">€
        <span class="margin-right"></span>
        <input type="number"
               class="size margin-right-small"
               [(ngModel)]="photographer.discountPercentage">%
        <div class="margin-top"
             [ngClass]="{'disable-div': statusIdToSetHiredData !== photographer.statusId}"
             [title]="statusIdToSetHiredData !== photographer.statusId ? 'This photographer is not hired' : ''">
          <div class="margin-bottom-small">Hired until</div>
          <div class="flex center">
            <div class="flex-1 margin-right">
              <input type="date"
                     class="full-width"
                     [disabled]="statusIdToSetHiredData !== photographer.statusId"
                     [min]="todayDate"
                     [(ngModel)]="hiredDate"
                     (ngModelChange)="onChangeDate()">
            </div>
            <div class="flex-1">
              <input type="checkbox"
                     [disabled]="statusIdToSetHiredData !== photographer.statusId"
                     [(ngModel)]="photographer.automaticRenewal">
              <label> Auto renewal</label>
            </div>
          </div>
          <div class="flex align-end"
               [ngClass]="{'margin-bottom-small': photographer.brands?.length}">
            <div class="flex-1 margin-right">
              <div class="margin-bottom-small margin-top">Brand</div>
              <bt-autocomplete [datasource]="brands.data"
                               [currentSelected]="brands.selected"
                               [settings]="brands.autocompleteSettings"
                               [loaderId]="brands.loaderId"
                               [disabledProperty]="statusIdToSetHiredData !== photographer.statusId"
                               (selected)="onSelectBrand($event)"></bt-autocomplete>
            </div>
            <div class="flex-1 margin-right">
              <div class="margin-bottom-small margin-top">Category</div>
              <bt-autocomplete [datasource]="categories.data"
                               [currentSelected]="categories.selected"
                               [settings]="categories.autocompleteSettings"
                               [loaderId]="categories.loaderId"
                               [disabledProperty]="!brands.selected || statusIdToSetHiredData !== photographer.statusId"
                               (selected)="onSelectCategory($event)"></bt-autocomplete>
            </div>
            <div class="flex-0">
              <button [disabled]="!brands.selected || statusIdToSetHiredData !== photographer.statusId"
                      (click)="addBrand()"><i class="fa fa-plus"></i>Add</button>
            </div>
          </div>
          @for(b of photographer.brands; track b){
            <ng-container>
              @if(!b.categories.length){
                <span class="chip margin-x-small">
                  {{b.brandName}} - All categ.
                  <i class="fa fa-times margin-left-small"
                     (click)="removeBrand(b)"></i>
                </span>
              } @else {
                <ng-container>
                  @for(c of b.categories; track c){
                    <span class="chip margin-x-small">
                      {{b.brandName}} - {{c.categoryName}}
                      <i class="fa fa-times margin-left-small"
                         (click)="removeBrand(b, c)"></i>
                    </span>
                  }
                </ng-container>
              }
            </ng-container>
          }
        </div>
      </bt-loader>
    </div>
  
    <div class="flex-0">
      <button class="full-width"
              [loaderId]="udapteLoaderId"
              (click)="onSave()"><i class="fa fa-save"></i>Save info</button>
    </div>
  </ng-container>
}
